import script from "./OfficeList.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficeList.vue?vue&type=script&setup=true&lang=js"

import "./OfficeList.vue?vue&type=style&index=0&id=392817e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392817e4"]])

export default __exports__